const FAV_KEY = "voix:favorites";
const HIST_KEY = "voix:history";
const EQ_KEY = "voix:eq";
const VOL_KEY = "voix:volume";
const ALARM_KEY = "voix:alarm";
const STATS_KEY = "voix:country_stats";
const HOURS_KEY = "voix:hours_stats";
const MOOD_KEY = "voix:mood_stats";

const read = (k, fallback) => {
  try {
    const raw = localStorage.getItem(k);
    return raw ? JSON.parse(raw) : fallback;
  } catch (err) {
    console.warn(`[voix] storage read failed for ${k}:`, err);
    return fallback;
  }
};
const write = (k, v) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch (err) {
    console.warn(`[voix] storage write failed for ${k}:`, err);
  }
};

const monthKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const storage = {
  getFavorites: () => read(FAV_KEY, []),
  toggleFavorite: (station) => {
    const list = read(FAV_KEY, []);
    const idx = list.findIndex((s) => s.stationuuid === station.stationuuid);
    if (idx >= 0) list.splice(idx, 1);
    else list.unshift(station);
    write(FAV_KEY, list.slice(0, 200));
    return list;
  },
  isFavorite: (uuid) => read(FAV_KEY, []).some((s) => s.stationuuid === uuid),

  getHistory: () => read(HIST_KEY, []),
  pushHistory: (station) => {
    const list = read(HIST_KEY, []).filter((s) => s.stationuuid !== station.stationuuid);
    list.unshift({ ...station, playedAt: Date.now() });
    write(HIST_KEY, list.slice(0, 50));
    return list;
  },
  clearHistory: () => { write(HIST_KEY, []); return []; },

  getEQ: () => read(EQ_KEY, { bass: 0, low: 0, mid: 0, high: 0, treble: 0, preset: "flat" }),
  setEQ: (eq) => write(EQ_KEY, eq),

  getVolume: () => read(VOL_KEY, 0.8),
  setVolume: (v) => write(VOL_KEY, v),

  // Alarm: { time: "07:30", station: {...}, enabled: true, lastFiredAtMinute: "..." }
  getAlarm: () => read(ALARM_KEY, null),
  setAlarm: (alarm) => write(ALARM_KEY, alarm),
  clearAlarm: () => { write(ALARM_KEY, null); return null; },

  // Country listening stats — rolls over per calendar month
  getStats: () => {
    const raw = read(STATS_KEY, { month: monthKey(), counts: {} });
    if (raw.month !== monthKey()) {
      const fresh = { month: monthKey(), counts: {} };
      write(STATS_KEY, fresh);
      return fresh;
    }
    return raw;
  },
  bumpCountry: (country) => {
    if (!country) return null;
    const cur = storage.getStats();
    cur.counts[country] = (cur.counts[country] || 0) + 1;
    write(STATS_KEY, cur);
    return cur;
  },

  getHours: () => {
    const raw = read(HOURS_KEY, { month: monthKey(), seconds: 0 });
    if (raw.month !== monthKey()) {
      const fresh = { month: monthKey(), seconds: 0 };
      write(HOURS_KEY, fresh);
      return fresh;
    }
    return raw;
  },
  addSeconds: (secs) => {
    if (!secs || secs <= 0) return null;
    const cur = storage.getHours();
    cur.seconds += secs;
    write(HOURS_KEY, cur);
    return cur;
  },

  getMoodStats: () => {
    const raw = read(MOOD_KEY, { month: monthKey(), counts: {} });
    if (raw.month !== monthKey()) {
      const fresh = { month: monthKey(), counts: {} };
      write(MOOD_KEY, fresh);
      return fresh;
    }
    return raw;
  },
  bumpMood: (mood) => {
    if (!mood) return null;
    const cur = storage.getMoodStats();
    cur.counts[mood] = (cur.counts[mood] || 0) + 1;
    write(MOOD_KEY, cur);
    return cur;
  },
};
